import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import language from './language';
import connect from './connect';
import upload from './upload';
import menu from './menu';
import user from './user';
import updater from './updater';
import qiniu from './qiniu';
import feedback from './feedback';
import project from './project';
import extension from './extension';
import sprite from './sprite';
import env from './env';
import dataChart from './dataChart';

const reducers = combineReducers({
    intlr: language.reducer,
    connect: connect.reducer,
    upload: upload.reducer,
    account: user.reducer,
    menu: menu.reducer,
    updater: updater.reducer,
    qiniu: qiniu.reducer,
    feedback: feedback.reducer,
    project: project.reducer,
    extension: extension.reducer,
    sprite: sprite.reducer,
    env: env.reducer,
    dataChart: dataChart.reducer
});

const store = createStore(reducers, applyMiddleware(thunk));

window.mstore = store;

export default store;